import React, { memo, useContext } from 'react';
import { IconViewGrid } from '@prisjakt/ui/icon/view-grid';
import { IconViewCompactList } from '@prisjakt/ui/icon/view-compact-list';
import type { Domain, TranslateFunc, Text } from 'src/components/translate';
import { AppContext } from 'src/components/app-context';
import type { ModeType } from './types';
import { LayoutPickerContainer, StyledButton } from './styles';

function translate<D extends Domain, T extends Text<D>>(
  transFunc: TranslateFunc,
  domain: D,
  field: T,
  data?: any
) {
  return transFunc ? transFunc(domain, field, data) : field;
}

const LayoutPicker: React.FC<LayoutPickerProps> = ({
  mode = 'row',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {},
}) => {
  const { t } = useContext(AppContext);
  return (
    <LayoutPickerContainer>
      <StyledButton
        onClick={() => onClick(mode === 'grid' ? 'row' : 'grid')}
        aria-label={translate(t, 'symbols', 'symbol.card-layout')}
      >
        {mode === 'row' ? (
          <IconViewGrid size={24} />
        ) : (
          <IconViewCompactList size={24} />
        )}
      </StyledButton>
    </LayoutPickerContainer>
  );
};

interface LayoutPickerProps {
  mode: ModeType;
  onClick: (mode: ModeType) => void;
}

export default memo(LayoutPicker);
